"use client";

import { LiquidPill } from "components/ui/v2/liquid-pill";
import { Pagination } from "components/ui/v2/pagination";
import { List } from "lucide-react";

export interface PagePaginationFooterV2Props {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  rangeLabel: React.ReactNode;
  perPageLabel?: string;
  siblingCount?: number;
}

export function PagePaginationFooterV2({
  currentPage,
  totalPages,
  totalItems: _totalItems,
  pageSize: _pageSize,
  onPageChange,
  rangeLabel,
  perPageLabel,
  siblingCount = 2,
}: PagePaginationFooterV2Props) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="border-t border-slate-200/70 pt-4 dark:border-zinc-800">
      <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-zinc-400">
          <List className="h-4 w-4" />
          <span>{rangeLabel}</span>
        </div>
        {perPageLabel ? (
          <LiquidPill variant="slate" size="sm" text={perPageLabel} />
        ) : null}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        siblingCount={siblingCount}
        className="w-full justify-center"
      />
    </div>
  );
}
